import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authAxios } from "../utils/axiosConfig";

// Async thunk to fetch users
export const fetchUsers = createAsyncThunk("users/fetchUsers", async () => {
	const response = await authAxios.get("/api/users");
	return response.data.users;
});

// Redux slice
const usersSlice = createSlice({
	name: "users",
	initialState: {
		usersList: [],
		loading: false,
		error: null,
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchUsers.pending, (state) => {
				state.loading = true;
			})
			.addCase(fetchUsers.fulfilled, (state, action) => {
				state.loading = false;
				state.usersList = action.payload;
			})
			.addCase(fetchUsers.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message;
			});
	},
});

export default usersSlice.reducer;
